import { css } from '@emotion/css';

import Platform from '@lyearn/core/utils/Platform';

export const questionEditorStyles = css`
  &.heading-m {
    font-size: 2rem;
    font-weight: normal;
    line-height: 4.8rem;
  }

  ${Platform.select({
    web: `img {
    display: inline-block;
    width: 1ch !important;
  }`,
    native: '',
  })}
`;

export const addBlankStyles = css`
  height: 4rem;
  width: fit-content;
`;
